import { FiTrash } from 'react-icons/fi';
import { HiOutlineDocumentReport } from 'react-icons/hi';
import { Link } from 'react-router-dom';
import { Container, Thumb, ContainerButtons } from './styles';

interface Props {
  id: number;
  name: string;
  urlImage: string;
  urlRedirect: string;
  onRemoveItem: (id: number) => void;
  onPushReport?: () => void;
}

export const ItemWithThumb = ({
  id,
  name,
  urlRedirect,
  urlImage,
  onRemoveItem,
  onPushReport,
}: Props) => (
  <Container>
    <Link to={urlRedirect}>
      <Thumb>
        <img src={urlImage} alt={name} />
      </Thumb>
      <h6>{name}</h6>
    </Link>
    <ContainerButtons>
      {onPushReport && (
        <button type="button" onClick={onPushReport}>
          <HiOutlineDocumentReport />
        </button>
      )}

      <button type="button" onClick={() => onRemoveItem(id)}>
        <FiTrash />
      </button>
    </ContainerButtons>
  </Container>
);
